import { FC } from 'react'
import styled from 'styled-components'
import { ActivityFilterItemById } from 'generated/graphql'
import SelectedFilterList from '@app.feature/activityFilter/components/SelectedFilterList'
import { FilterByKeys } from '../../context'
import { useRecruitFilterChips } from './RecruitFilterChips.module'

export interface FilterListItem<T = ActivityFilterItemById> {
  filterTitle: string
  filterItems: Array<T>
  filterKey: FilterByKeys
}

interface RecruitFilterChipsMobileProps {
  filterList: FilterListItem[]
  className?: string
}

const RecruitFilterChipsMobile: FC<RecruitFilterChipsMobileProps> = (props) => {
  const { filterList, className } = props
  const { selectedFilterMobileItems, onChipRemoveMobile, onReset } =
    useRecruitFilterChips(filterList)

  if (selectedFilterMobileItems.length === 0) {
    return null
  }

  return (
    <StyledWrapper className={className}>
      <SelectedFilterList
        items={selectedFilterMobileItems.map((item) => ({
          id: item.id,
          label: item.name,
          name: item.fieldKey,
          order: item.order,
        }))}
        onRemove={(item) => {
          onChipRemoveMobile({
            fieldKey: item.name as FilterByKeys,
            id: item.id,
            name: item.label,
          })
        }}
        onReset={onReset}
      />
    </StyledWrapper>
  )
}

export default RecruitFilterChipsMobile

const StyledWrapper = styled.div`
  padding: 8px 0 0 20px;
`
